<template>

    <v-col>

      <v-snackbar
          light
          centered
          v-model="snackbar"
          :multi-line="true"
      >
        Your Message has been sent!

        <template v-slot:action="{ attrs }">
          <v-btn
              color="red"
              text
              v-bind="attrs"
              @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>


      <v-form ref="ContactForm" v-model="formValid">
        <h5 class="ml-1 mr-1 text-start">Name</h5>
        <v-text-field
            :rules="[v => !!v || 'Name is required']"
            v-model="name" outlined placeholder="Enter Your Name"></v-text-field>
        <h5 class="ml-1 mr-1 text-start">Email</h5>
        <v-text-field
            :rules="[v => !!v || 'Email is required']"
            v-model="email" outlined placeholder="Enter Your Email"></v-text-field>
        <h5 class="ml-1 mr-1 text-start">Phone</h5>
        <v-text-field
            :rules="[v => !!v || 'Phone is required']"
            v-model="phone_number" outlined placeholder="Enter Your Phone Number"></v-text-field>

        <h5 class="ml-1 mr-1 text-start">Subject</h5>
        <v-text-field
            :rules="[v => !!v || 'Subject is required']"
            v-model="subject" outlined placeholder="Enter Your Subject"></v-text-field>
        <h5 class="ml-1 mr-1 text-start">Message</h5>
        <v-textarea
            :rules="[v => !!v || 'Message is required']"
            v-model="message" outlined placeholder="Enter Your Message"></v-textarea>
        <v-row justify="center" no-gutters>
          <v-btn @click="submitMessage" :loading="loading" :outlined="$route.path === '/'"  height="56" :color="$route.path === '/' ? 'white':'primary'" dark>Send</v-btn>
        </v-row>
      </v-form>
    </v-col>

</template>

<script>
import axios from "axios";

export default {
  name: "ContactForm",
  data: ()=> ({
    loading: false,
    snackbar: false,
    formValid:null,
    name:null,
    email:null,
    phone_number:null,
    subject:null,
    message:null
  }),
  methods:{
    async submitMessage(){
      await this.$refs.ContactForm.validate();

      if (this.formValid){
        this.loading = true;
        axios.post('https://admin.wca.innocube.lk/api/contact-us',{
          name:this.name,
          email:this.email,
          phone_number:this.phone_number,
          subject:this.subject,
          message:this.message
        }).then(response=>{
          console.log(response);
          this.loading = false;
          this.snackbar = true;
        }).catch(error=>{
          this.loading = false;
          console.log(error);
        });
      }
    }
  },
  mounted() {
    console.log(this.$route.path)
  }
}
</script>

<style scoped>

</style>
